<template>
  <div>
    <topmenu></topmenu>

    <div class="container">
      <div class="list-con">
        <div class="left">
          <div class="nav">
               <span class="text">当前位置：首页 <span class="ico"><img src="../../assets/img/6.png" alt=""></span> {{plate}}</span>
          </div>
          <div class="column-list clearfix">
            <!-- <p v-for="(item,i) in columnlist" :title="item.title" :id="item.id">
              {{item.title}}
            </p>-->
             <columnbox v-for="(item,i) in columnlist" :title="item.title" :id="item.id"  :key="item.id"></columnbox>
          </div>
        </div>
        <div class="right">
         <rightnews :myProp="toChildA" :myPropType="toChildAType"></rightnews>
         <rightnews :myProp="toChildB" :myPropType="toChildBType"></rightnews>
        </div>
      </div>
    </div>
    <bottomfooter></bottomfooter>
  </div>
</template>

<script>
import topmenu from '@/views/front/components/topmenu';
import bottomfooter from '@/views/front/components/bottomfooter';
import rightnews from '@/views/front/components/rightnews';
import newslist from '@/views/front/components/newslist';
import columnbox from '@/views/front/components/columnbox';

export default {
  name: 'Column',
  components: {
    topmenu,
    bottomfooter,
    rightnews,
    newslist,
    columnbox
  },
  data() {
   return {
     plate:this.$route.query.text||'',
     menuid:this.$route.query.menuid||'',
     toChildA: '新闻动态',
     toChildB: '基层信息',
     toChildAType: '1',
     toChildBType: '3',
     columnlist:[
       {
         //id:'1',
         //title:''
       }
     ]
   };
  },
  watch:{
     '$route' (to,from){
       if(to.query.text!= from.query.text){
         this.plate = to.query.text;
         this.menuid = to.query.menuid;
       }
     }
  },
  created(){
    if(this.$route.query){
      this.menuid = this.$route.query.menuid;
      console.log(this.menuid)
      this.init();
    }
  },
 mounted() {

},
  methods: {
    init(){

        if(this.menuid == '16'){
            console.log(this.menuid)
             this.columnlist=[
              // {
              //   id:'16',
              //   title:'市残疾人康复中心'
              // },
              // {
              //   id:'19',
              //   title:'聋儿听力语言康复'
              // },
              // {
              //   id:'17',
              //   title:'智力障碍康复'
              // },
              // {
              //   id:'20',
              //   title:'小儿脑瘫康复'
              // },
              // {
              //   id:'18',
              //   title:'社区康复指导'
              // }
			  {
			    id:'40',
			    title:'社会保障'
			  }
            ]

          }//就业就业
          if(this.menuid == '21'){
            console.log(this.menuid)
            this.columnlist=[
              // {
              //   id:'21',
              //   title:'就业服务中心职能'
              // },
              {
                id:'22',
                title:'残疾人就业'
              },
              {
                id:'23',
                title:'残疾人职业培训'
              },
              {
                id:'24',
                title:'盲人按摩'
              },
              {
                id:'25',
                title:'按比例安排残疾人就业审核'
              }
            ]
          }
          //康复工作
          if(this.menuid == '30'){
            console.log(this.menuid)
            this.columnlist=[
              {
                id:'30',
                title:'康复中心动态'
              },
			  {
			    id:'35',
			    title:'工作动态'
			  },
             
              {
                id:'31',
                title:'康复小知识'
              },
              {
                id:'34',
                title:'康复政策'
              },
              {
                id:'32',
                title:'康复项目'
              }
							// ,
       //        {
       //          id:'36',
       //          title:'康复进农村进社区工作'
       //        }
              //,
              // {
              //   id:'33',
              //   title:'创建“白内障无障碍市”工作'
              // }
            ]
          }
          //教育就业
          if(this.menuid == '37'){
            console.log(this.menuid)
            this.columnlist=[
				{
				  id:'39',
				  title:'工作动态'
				},
              {
                id:'37',
                title:'融合教育工作'
              }
             
			  // ,
     //          {
     //            id:'38',
     //            title:'扶贫'
     //          }
	 
              // {
              //   id:'40',
              //   title:'社会保障'
              // }
            ]
          }

          //残疾人维权
          if(this.menuid == '41'){
            console.log(this.menuid)
            this.columnlist=[
              {
                id:'41',
                title:'维权部工作职能'
              },
              {
                id:'43',
                title:'政策规定'
              },
              {
                id:'42',
                title:'维权工作'
              }
            ]
          }


    }
  }
};
</script>

<style scoped>
  .list-con{
    display: flex;
    justify-content: space-between;
  }
  .column-list{
    margin-top:20px;
    padding-bottom: 40px;
  }
  .left{
    width:63%;
  }
  .right{
    width:35%;
  }
  .nav{
    background:#efefef;
    padding:10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Front/Column.vue